module.exports = __webpack_public_path__ + "share_icon_black.png";